import StorageService from '@/services/storage.service'
import storageKeys from '@/constants/storageKeys'
import { defaultFilters } from '@/models/BudgetRequestsLog/helpers'
import budgetRequestsLogRepository from '@/repository/generatedRepository/budgetRequestsLogRepository'
import TableOptions from '@/models/TableOptions'
import { omitEmptyDeepFilters, prepareFilters } from '@/helpers/filters'
import { downloadExportFile } from '@/helpers/export'
const { saveAs } = require('file-saver')

const state = {
  list: [],
  filters: StorageService.get(storageKeys.BUDGET_REQUESTS_LOG_FILTERS) || { ...defaultFilters() },
  tableOptions: TableOptions.defaultTableOptions(),
}

const getters = {
  filters: state => state.filters,
  tableOptions: state => state.tableOptions,
  list: state => state.list,
  isOpenFilterPanel: state =>
    state.filters.clientOptions && state.filters.clientOptions.filterPanelExpanded,
}

const actions = {
  async loadData(context, filters) {
    context.commit('setFilters', filters)
    StorageService.set(storageKeys.BUDGET_REQUESTS_LOG_FILTERS, filters)

    const appliedFilters = omitEmptyDeepFilters(filters.filter)
    const appliedCfFilters = omitEmptyDeepFilters(filters.cfFilter)

    const preparedFilters = prepareFilters({
      ...filters,
      filter: appliedFilters,
      cfFilter: appliedCfFilters,
    })

    const { data } = await budgetRequestsLogRepository.list(preparedFilters)

    context.commit('setList', { data, filters })

    return { products: data.items, pagination: data.pagination }
  },
  async loadExportFile(context, filters) {
    const appliedFilters = omitEmptyDeepFilters(filters.filter)
    const appliedCfFilters = omitEmptyDeepFilters(filters.cfFilter)

    const preparedFilters = prepareFilters({
      ...filters,
      filter: appliedFilters,
      cfFilter: appliedCfFilters,
    })

    await downloadExportFile(budgetRequestsLogRepository.exportBudgetRequestsLogToken(preparedFilters))
  },
  async searchBudgetRequestsLog(context, filters) {
    const appliedFilters = omitEmptyDeepFilters(filters.filter)
    const preparedFilters = prepareFilters({
      ...filters,
      filter: appliedFilters,
    })

    const { data } = await budgetRequestsLogRepository.list(preparedFilters)

    return { products: data.items, pagination: data.pagination }
  },
  async loadItem(context, id) {
    const { data } = await budgetRequestsLogRepository.get(id)
    return data
  },
  async downloadFile(context, {id, ...payload}) {
    const response = await budgetRequestsLogRepository.downloadFile(id)
    const blob = new Blob([response.data], { type: response.headers['content-type'] })
    saveAs(blob, `request_${payload.createdAt}.xlsx`)
    return response
  },
  async downloadWarningsFile(context, {id, ...payload}) {
    const response = await budgetRequestsLogRepository.downloadWarningsFile(id)
    const blob = new Blob([response.data], { type: response.headers['content-type'] })
    saveAs(blob, `warnings_${payload.createdAt}.xlsx`)
    return response
  },
  createItem(context, payload) {
    return budgetRequestsLogRepository.post(payload)
  },
  updateItem(context, payload) {
    const { id, ...data } = payload
    return budgetRequestsLogRepository.put(id, data)
  },
  deleteItem(context, payload) {
    return budgetRequestsLogRepository.delete(payload)
  },
  filtersStorageReset() {
    StorageService.remove(storageKeys.BUDGET_REQUESTS_LOG_FILTERS)
  },
  updateFiltersClientOptions({ commit, getters }, clientOptions) {
    const updatedFilters = {
      ...getters.filters,
      clientOptions,
    }
    commit('setFilters', updatedFilters)
    StorageService.set(storageKeys.BUDGET_REQUESTS_LOG_FILTERS, updatedFilters)
  },
}

const mutations = {
  setList(state, { data, filters }) {
    state.list = [...data.items]
    state.tableOptions = new TableOptions(data.pagination, filters)
  },
  setFilters(state, filters) {
    state.filters = { ...filters }
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
